import { Model$ListingGroup } from '../ApiType';
import { PostOdataAdsAPIParams, getFullUrlOfAdsOdata } from './adsOdata';

export interface DateRange {
  /**
   * YYYY-MM-DD
   *
   * @example 2022-05-15
   */
  EndDate: string;
  /**
   * YYYY-MM-DD
   *
   * @example 2022-05-02
   */
  StartDate: string;
}

interface GetListingGroupGridDataPayload {
  gridDataParameters: {
    DateRange: DateRange;
  },
}

export type GetListingGroupGridDataParmas = PostOdataAdsAPIParams<GetListingGroupGridDataPayload>;

interface GetListingGroupGridDataResponseBody {
  value: Model$ListingGroup[];
}

export function listingGroupGridDataRequest(baseUrl: string, params: GetListingGroupGridDataParmas) {
  const path = 'ProductListingGroups/Default.GridData';
  const finalUrl = getFullUrlOfAdsOdata(baseUrl, path, params);
  return [finalUrl, {
    method: 'POST',
    headers: {
      'x-ms-lastwritetime': 'Max',
    },
    body: JSON.stringify(params.payload),
  }];
}

export async function listingGroupGridDataResponseHandler(responsePromise: Promise<Response>) {
  const response = await responsePromise;
  const responseBody: GetListingGroupGridDataResponseBody = await response.json();
  return responseBody;
}
